import React from 'react'
import { Popover } from 'antd'
import './index.less'

const Index = ({ overlayClassName = 'tooltip', children, placement = 'bottom', autoAdjustOverflow = true, arrowPointAtCenter = true, zIndex = 2000, ...otherProps }) => {
  return (
    <Popover
      overlayClassName={`cross-border-popover ${overlayClassName}`}
      placement={placement}
      zIndex={zIndex}
      autoAdjustOverflow={autoAdjustOverflow}
      arrowPointAtCenter={arrowPointAtCenter}
      {...otherProps}
    >
      {children}
    </Popover>
  )
}

export default Index
